import React from 'react'
import {Navbar, Page, PageContent} from "framework7-react";
import {MainToolBar} from "../MainLayout/MainToolBar";
import {useTranslation} from "react-i18next";
export const Promotion = () => {
    const { t } = useTranslation();
    return (
        <Page>
            <Navbar title={`${t("navigation.promote")}`} backLink="Back" />
            <PageContent>
                Promote page
            </PageContent>
            <MainToolBar />
        </Page>
    );
}